import PropTypes from 'prop-types';
import V360Info from './V360Info';
import css from './V360Info.scss';

export const classes = {
	v360Info: css.v360Info,
	v360InfoTitle: css.v360InfoTitle,
	v360InfoText: css.v360InfoText,
};

V360Info.propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
};

V360Info.defaultProps = {
	className: '',
	classes,
};

export { V360Info };
export default V360Info;